import React from "react";
import { lazy } from "react";

const ProcessType = lazy(() => import("./ProcessType"));
const ProcessTypeProcesses = lazy(() => import("./ProcessTypeProcesses"));
const Schedule = lazy(() => import("./Schedule"));
const ScheduleSettings = lazy(() => import("./ScheduleSettings"));
const ProcessMapping = lazy(() => import("./ProcessMapping"));
const EmployeeProcesses = lazy(() => import("./EmployeeProcesses"));
const MachineSetup = lazy(() => import("./MachineSetup"));
const SupervisorMapping = lazy(() => import("./SupervisorMapping"));

const processManagementRoutes = [
    {
        path: "/process-management/process-type",
        element: <ProcessType />
    },
    {
        path: "/process-management/process-type/processes",
        element: <ProcessTypeProcesses />
    },
    {
        path: "/process-management/process-type/:id/processes",
        element: <ProcessTypeProcesses />
    },
    {
        path: "/process-management/schedule",
        element: <Schedule />
    },
    {
        path: "/process-management/schedule/settings/:id",
        element: <ScheduleSettings />
    },
    {
        path: "/process-management/employee-process",
        element: <ProcessMapping />
    },
    {
        path: "/process-management/employee-processes",
        element: <EmployeeProcesses />
    },
    { path: "/process-management/machine-setup", element: <MachineSetup /> },
    { path: "/process-management/supervisor-mapping", element: <SupervisorMapping /> }
];

export default processManagementRoutes;
